import { useState, type FormEvent } from 'react';
import { useLocation } from 'wouter';
import { toast } from 'sonner';
import { Sparkles } from 'lucide-react';
import { useLogin, useMe } from '../lib/hooks';
import { useT } from '../lib/i18n';

export function LoginPage() {
  const t = useT();
  const [, navigate] = useLocation();
  const [email, setEmail] = useState('oanh@dev-myos.de');
  const [password, setPassword] = useState('change-me-now-please');
  const me = useMe();
  const login = useLogin();

  if (me.data) {
    navigate('/', { replace: true });
  }

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await login.mutateAsync({ email, password });
      toast.success('Đăng nhập thành công');
      navigate('/', { replace: true });
    } catch {
      toast.error(t('login.failed'));
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <form onSubmit={onSubmit} className="panel w-full max-w-sm">
        <div className="px-7 pt-7 pb-2 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-fuchsia-500 shadow-lg shadow-indigo-500/40">
            <Sparkles className="h-5 w-5 text-white" />
          </div>
          <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100">Personal OS</h1>
          <p className="mt-1 text-sm text-slate-500">{t('login.title')}</p>
        </div>
        <div className="space-y-4 px-7 pt-4 pb-7">
          <div>
            <label className="label">{t('login.email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
              required
              autoFocus
            />
          </div>
          <div>
            <label className="label">{t('login.password')}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input"
              required
            />
          </div>
          <button type="submit" className="btn-primary w-full" disabled={login.isPending}>
            {login.isPending ? '…' : t('login.submit')}
          </button>
        </div>
      </form>
    </div>
  );
}
